<template>
    <div class="card">
            <div class="card-title">
                <slot name="card-title">
                    <h2 v-if="$props.title" :class="$props.titleClasses">{{$props.title}}</h2>
                </slot>              
            </div>            
        
        <div class="card-body" :class="$props.bodyClasses">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    
    props: {
        title: { type: String, default: '' },
        titleClasses: { type: String, default: '' },
        url: { type: String },
        bodyClasses: { type: String, default: '' },
    },

    setup () {        
        return {

        }
    }

}
</script>

<style lang="css" scoped>
.card
{ @apply rounded-xl flex flex-col relative; }

.card-title
{ @apply flex items-center text-white bg-gray-500 bg-opacity-70 text-xl rounded-t-xl p-3 h-12; }

.card-body
{ @apply flex bg-white mt-2 items-center rounded-b-xl text-justify; }
</style>